import React from 'react';

import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './web.config';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import App from './App';

/* eslint-disable no-undef */
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_KEY}>
      <App />
    </GoogleReCaptchaProvider>
  </BrowserRouter>,
);
